import { Table } from "./Table";
import { Form } from "./Form";

export const Operation = {
  Table,
  Form,
};
